import React from "react";
import { Space, Button } from "@masterteam/mt-design-react";

import { ReactComponent as DualArrowLeft } from "../../../assets/images/dual-arrow-left.svg";
import { ReactComponent as DualArrowRight } from "../../../assets/images/dual-arrow-right.svg";
import { ReactComponent as ArrowLeft } from "../../../assets/images/arrow-left.svg";
import { ReactComponent as ArrowRight } from "../../../assets/images/arrow-right.svg";

import useIsAr from "../../../Hooks/useIsAr";

import "./style.scss";

function MovementControls({
  onChange,
  assigned,
  unassigned,
  allSelected,
  nothingSelected
}) {
  const [isAr] = useIsAr();

  return (
    <Space
      direction="vertical"
      size="medium"
      className="users-groups-picker__movement-controls"
    >
      <Space direction="vertical" className="controls-group">
        <Button
          variant="primary"
          size="small"
          disabled={!assigned?.length}
          shape="square"
          Icon={isAr ? ArrowLeft : ArrowRight}
          onClick={() => onChange("assign")}
        />
        <Button
          variant="primary"
          size="small"
          disabled={!unassigned?.length}
          shape="square"
          Icon={isAr ? ArrowRight : ArrowLeft}
          onClick={() => onChange("unassign")}
        />
      </Space>
      <Space direction="vertical" className="controls-group">
        <Button
          variant="primary"
          size="small"
          disabled={allSelected}
          shape="square"
          Icon={isAr ? DualArrowLeft : DualArrowRight}
          onClick={() => onChange("assign-all")}
        />
        <Button
          variant="primary"
          size="small"
          disabled={nothingSelected}
          shape="square"
          Icon={isAr ? DualArrowRight : DualArrowLeft}
          onClick={() => onChange("unassign-all")}
        />
      </Space>
    </Space>
  );
}

export default MovementControls;
